/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function FilmStrip(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M208,64h24V56a16.01833,16.01833,0,0,0-16-16H40A16.01833,16.01833,0,0,0,24,56v8H48a8,8,0,0,1,0,16H24v96H48a8,8,0,0,1,0,16H24v8a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16v-8H208a8,8,0,0,1,0-16h24V80H208a8,8,0,0,1,0-16ZM108,192H88a8,8,0,0,1,0-16h20a8,8,0,0,1,0,16Zm0-112H88a8,8,0,0,1,0-16h20a8,8,0,0,1,0,16Zm60,112H148a8,8,0,0,1,0-16h20a8,8,0,0,1,0,16Zm0-112H148a8,8,0,0,1,0-16h20a8,8,0,0,1,0,16Z" />
    </Svg>
  );
}

export default FilmStrip;
